module.exports = __webpack_public_path__ + "static/media/gq_logo.1e80feb0.png";